/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { wxConfig, wxShare } from "@src/utils/wechat"
import Nav from "@components/nav"
import Seo from "@components/seo"
import image1 from "@images/ticket.png"
import image01 from "@images/prepare-boy.gif"
import image02 from "@images/prepare-door.png"

import classnames from "gpages/utils/classnames"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { useBrowserLayout } from "gpages/hooks/layout"
import Prepare from "@src/components/prepare"
import { useScrollEvent } from "gpages/hooks/common"

const preprepareImgs = [image01, image02]
const prepareImgs = [image1]
const prepareGroup = [preprepareImgs, prepareImgs]

const Layout = ({ children, location }) => {
  const [scrolled, setScrolled] = useState(false)
  const { isAppLayout, isMobile, renderItem } = useBrowserLayout({
    appWidth: 1000,
  })
  const [ready, setReady] = useState(prepareGroup.map(() => false))
  const [prepareEnd, setPrepareEnd] = useState(false)
  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  useEffect(() => {
    // 准备好图片组的记载完成标记
    const allCheck = prepareGroup.map((x) => ({ isReady: false }))

    const prepare = (checkObj, imgs) => {
      let count = 0
      const len = imgs.length
      const counter = () => {
        count++
        if (count === len) {
          checkObj.isReady = true
        }
      }
      imgs.forEach((src) => {
        const img = new Image()
        img.onload = counter
        img.src = src
      })
    }

    prepareGroup.forEach((imgs, index) => {
      prepare(allCheck[index], imgs)
    })

    const check = setInterval(() => {
      setReady(allCheck.map((x) => x.isReady))
      if (allCheck.every((x) => x.isReady)) {
        clearInterval(check)
      }
    }, 300)

    // 无论是否加载完成，一定时间后后都展示页面
    setTimeout(() => {
      setPrepareEnd(true)
      setReady(allCheck.map((x) => true))
      clearInterval(check)
    }, 8000)
  }, [])

  // 当滑动后再加载后续内容
  // 避免一开始加载太多图片，且会阻塞首屏视频加载
  useScrollEvent(
    () => {
      setScrolled(true)
    },
    { firstTrigger: false }
  )

  // 当图片准备好，且动画完成后
  const allReady = ready.every((x) => x) && prepareEnd

  return (
    <AppContext.Provider
      value={{ isAppLayout, isMobile, ready: allReady, scrolled, renderItem }}
    >
      <Prepare
        ready={allReady}
        readyData={ready}
        onAnimationEnd={() => {
          setPrepareEnd(true)
        }}
      />
      <Seo />
      <Nav location={location} />
      <div
        className={classnames(styles.container, {
          [styles.ready]: allReady,
        })}
      >
        <main>{children}</main>
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
